import { render, staticRenderFns } from "./coachPerf.vue?vue&type=template&id=71ccd97c&scoped=true"
import script from "./coachPerf.vue?vue&type=script&lang=js"
export * from "./coachPerf.vue?vue&type=script&lang=js"
import style0 from "./coachPerf.vue?vue&type=style&index=0&id=71ccd97c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ccd97c",
  null
  
)

export default component.exports